import React from 'react';
import { Box, Button, TextField } from '@mui/material';
import Tip from './Tip';
import HTMLContent from './HTMLContent';
import AnswerResult from './AnswerResult';
import useQuestionAnswer from '../../hooks/useQuestionAnswer';

export default function ValidatedInput(props) {
  const { answer, result, change, check } = useQuestionAnswer(props.questionKey, '');
  const resultId = props.questionKey ? `${props.questionKey}-result` : undefined;
  const unitId = props.questionKey ? `${props.questionKey}-unit` : undefined;
  return <Box sx={{ width: '100%', minWidth: 0 }}>
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
      {props.equation && <HTMLContent content={`${props.equation} = `} />}
      <TextField label={props.field || 'Answer'} size="small" value={answer}
        error={result === false || result === 'empty'} onChange={event => change(event.target.value)}
        inputProps={{ 'aria-describedby': [props.directionsId, props.unitOfMeasure && unitId, result !== null && resultId].filter(Boolean).join(' ') || undefined }}
        sx={{ width: props.answerLength === 'Xlarge' ? '20rem' : '16rem', maxWidth: '100%' }} />
      {props.unitOfMeasure && <Box id={unitId}><HTMLContent content={props.unitOfMeasure} /></Box>}
      <Button type="button" variant="outlined" aria-describedby={props.directionsId}
        onClick={() => check(answer.trim() === '' ? null : (props.validAnswers || []).includes(answer))}>Check</Button>
      <Tip tip={props.tip} describedBy={props.directionsId} />
    </Box>
    <AnswerResult id={resultId} result={result} />
  </Box>;
}
